import { IAzureMapFeatureType } from "react-azure-maps";
import { data } from "azure-maps-control";

import { MapItemResponse } from "../../api-models/response/MapItemResponse";
import { RowDetails } from "../../api-models/response/DataGridResponse";
import { formatValues } from "../../components/datatable/GridValuesFormatter";
import { SewerObjectType } from "../../generated/SewerObjects";

export class MapItem {
  mapShapeType: IAzureMapFeatureType;
  mapCoordinates: data.Position[];
  objectName: string;
  objectType: SewerObjectType;
  objectId: number;
  details: RowDetails;

  constructor(mapItem: MapItemResponse) {
    this.mapShapeType = mapItem.type === "Point" ? "Point" : "LineString";
    this.mapCoordinates = mapItem.coordinates.map(
      (c) => new data.Position(c.latitude, c.longitude)
    );
    this.details = formatValues(mapItem.details) as RowDetails;
    this.objectName = mapItem.name;
    this.objectType = mapItem.objectType;
    this.objectId = mapItem.objectId;
  }

  get hasGeometry() {
    return this.mapCoordinates.length > 0;
  }
}
